<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            v-model="modalPromptPay.show"
            size="md"
        >
            <card shadow type="secondary" class="m--4">
                <div class="row">
                    <div class="col-12">
                        <span class="close cursor-pointer" @click="close()">&times;</span>
                    </div>
                </div>
                <div class="row text-center">
                    <div class="col-lg-12 py-4">
                        <h3>{{ (modalPromptPay.type === 'CREATE') ? 'เพิ่มช่องทางการรับชำระ' : 'แก้ไขช่องทางการรับชำระ' }}</h3> 
                    </div>
                </div>
                <form class="px-3" @submit.prevent="onSubmit()">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> ช่องทางรับชำระ
                                </label>
                                <v-select 
                                    class="w-100"
                                    placeholder="--- กรุณาเลือกธนาคาร ---"
                                    label="name"
                                    :options="bank"
                                    :key="modalPromptPay.bankCode"
                                    v-model="modalPromptPay.bankCode"
                                    :reduce="formatBank => formatBank.code"
                                >
                                </v-select>
                            </div>
                        </div>
                        <div class="col-lg-12">
                            <div class="form-group">
                                <label>
                                    <span class="text-danger">*</span> เลขบัตรประชาชน หรือ เบอร์มือถือ
                                </label>
                                <input
                                    v-model="modalPromptPay.number"
                                    class="form-control"
                                    placeholder="เลขบัตรประชาชน หรือ เบอร์มือถือ"
                                    :class="{ 'is-invalid': submitForm && $v.modalPromptPay.number.$error }"
                                />
                                <label
                                    v-if="submitForm && !$v.modalPromptPay.number.required"
                                    class="invalid-feedback"
                                >
                                    กรุณากรอกเลขบัตรประชาชน หรือ เบอร์มือถือ
                                </label>
                                <label class="error invalid-feedback" v-if="!$v.modalPromptPay.number.minLength">
                                    กรุณากรอกเลขบัตรประชาชน หรือ เบอร์มือถือ อย่างน้อย {{$v.modalPromptPay.number.$params.minLength.min}} ตัวเลข
                                </label>
                                <label class="error invalid-feedback" v-if="!$v.modalPromptPay.number.maxLength">
                                    กรุณากรอกเลขบัตรประชาชน หรือ เบอร์มือถือ ไม่เกิน {{ $v.modalPromptPay.number.$params.maxLength.max }} ตัวเลข
                                </label>
                                <label v-if="submitForm && !$v.modalPromptPay.number.checkTax" class="invalid-feedback">
                                    กรุณากรอกเลขบัตรประชาชนให้ถูกต้อง
                                </label>
                            </div>
                        </div>
                        <div class="col-lg-12 text-center">
                            <b-button 
                                class="px-5" 
                                variant="secondary" 
                                @click="close()"
                            >
                                ยกเลิก
                            </b-button>
                            <b-button 
                                class="px-5" 
                                variant="primary"
                                type="submit"
                                :disabled="isLoading"
                            >
                                <i class="fas fa-circle-notch fa-spin" v-if="isLoading"></i> ยืนยัน
                            </b-button>
                        </div>
                    </div>
                </form>
            </card>
        </b-modal>
    </div>
</template>

<script>
import { 
    required,
    minLength,
    maxLength
} from "vuelidate/lib/validators"
import { checkTax } from "@/plugins/posHelper.js";
import { addBanking, updateBanking } from "@/axios/bank.js"
import { showErrorModal } from "@/components/modalNotification.js";

export default {
    props: {
        modalPromptPay: Object,
    },
    data: () => ({
        bank: [
            { code:"999", name:"พร้อมเพย์" }
        ],
        submitForm: false,
        isLoading: false
    }),
    validations() {
        return {
            modalPromptPay:{
                number: { 
                    required, 
                    minLength: minLength(9), 
                    maxLength: maxLength(13), 
                    ...(this.modalPromptPay.number.length > 10 ) ? { checkTax } : ''
                }
            }
        }
    },
    methods:{
        onSubmit(){
            this.submitForm = true;
            this.$v.modalPromptPay.$touch();
            if (this.$v.modalPromptPay.$invalid) {
                return false
            }
            this.submitForm = false;
            this.isLoading = true;

            if ( this.modalPromptPay.type === 'CREATE' ){
                addBanking( this.$route.params.Id , this.modalPromptPay ).then( res => {
                    this.$emit('emitReloadShopBank')
                    this.close()
                }).catch(error => {
                    showErrorModal( error )
                })
            }else{
                updateBanking(this.$route.params.Id , this.modalPromptPay.id , this.modalPromptPay).then( res => {
                    this.$emit('emitReloadShopBank')
                    this.close()
                }).catch(error => {
                    showErrorModal( error )
                })
            }
        },
        close(){
            this.isLoading = false
            this.modalPromptPay.show = false;
            this.modalPromptPay.number = '';
            this.id = null
            this.submitForm = false
        }
    }
}
</script>
